export const LOADING_FACTORES_CRITICIDAD = "LOADING_FACTORES_CRITICIDAD";
export const SAVE_LOADING_FACTORES_CRITICIDAD =
  "SAVE_LOADING_FACTORES_CRITICIDAD";
export const GET_FACTORES_CRITICIDAD = "GET_FACTORES_CRITICIDAD";
export const FORM_FAIL = "FORM_FAIL";
export const FACTORES_CRITICIDAD_FAIL = "FACTORES_CRITICIDAD_FAIL";
